// extracted by mini-css-extract-plugin
module.exports =  {"container":"_25d45facb5--container--fm0ly","avatar":"_25d45facb5--avatar--lFwRk","user-name":"_25d45facb5--user-name--af82U","label":"_25d45facb5--label--mFlv3"};